"use client";

const Specialization = ({ data }) => {
  const bgColors = [
    "bg-[#D6E4FF]", // Light Blue
    "bg-[#D1F0E4]", // Light Green
    "bg-[#FFE9A7]", // Light Yellow
    "bg-[#FFD9D6]", // Light Red/Pink
    "bg-[#C2F0EA]", // Aqua Green
  ];

  if (
    !data.section[3] ||
    !data.section[3].isActive ||
    !data.section[3].body ||
    !Array.isArray(data.section[3].body.list1) ||
    data.section[3].body.list1.length === 0
  ) {
    return <div></div>;
  }

  return (
    <div
      className="mt-12 mx-auto px-6 md:px-[90px] py-12"
      style={{
        background:
          "linear-gradient(90deg, rgba(255, 153, 0, 0.05) 0%, rgba(4, 35, 107, 0.05) 100%)",
      }}
    >
      <h1 className="text-center text-primary-color text-2xl md:text-3xl font-semibold">
        Top Specialization for{" "}
        <span className="text-secondary-color">{data.programName}</span>
      </h1>

      <div className="mx-auto mt-10 flex justify-center flex-wrap max-w-[1500px]">
        {data.section[3].body.list1.map((item, index) => (
          <h2
            key={index}
            className={`m-2 md:m-3 px-5 md:px-7 py-2 md:py-2.5 text-sm md:text-lg font-semibold text-[#2B2B2B] rounded-full ${
              bgColors[index % bgColors.length]
            }`}
          >
            {item.title}
          </h2>
        ))}
      </div>
    </div>
  );
};

export default Specialization;
